// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IRunOutPropertyDto
 */
export interface IRunOutPropertyDto {
    /**
     * 
     * @type {number}
     * @memberof IRunOutPropertyDto
     */
    run_out_days_amount?: number;
    /**
     * 
     * @type {string}
     * @memberof IRunOutPropertyDto
     */
    run_out_type?: IRunOutPropertyDtoRunOutTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IRunOutPropertyDto
     */
    run_out_type_state?: IRunOutPropertyDtoRunOutTypeStateEnum;
}

/**
* @export
* @enum {string}
*/
export enum IRunOutPropertyDtoRunOutTypeEnum {
    LAST_DAY_OF_PLAN_YEAR = 'LAST_DAY_OF_PLAN_YEAR',
    CUSTOM = 'CUSTOM',
    NO_CLAIMS_DEADLINE = 'NO_CLAIMS_DEADLINE'
}
/**
* @export
* @enum {string}
*/
export enum IRunOutPropertyDtoRunOutTypeStateEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}


/**
 * Check if a given object implements the IRunOutPropertyDto interface.
 */
export function instanceOfIRunOutPropertyDto(value: object): value is IRunOutPropertyDto {
    return true;
}

export function IRunOutPropertyDtoFromJSON(json: any): IRunOutPropertyDto {
    return IRunOutPropertyDtoFromJSONTyped(json, false);
}

export function IRunOutPropertyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IRunOutPropertyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'run_out_days_amount': json['run_out_days_amount'] == null ? undefined : json['run_out_days_amount'],
        'run_out_type': json['run_out_type'] == null ? undefined : json['run_out_type'],
        'run_out_type_state': json['run_out_type_state'] == null ? undefined : json['run_out_type_state'],
    };
}

export function IRunOutPropertyDtoToJSON(json: any): IRunOutPropertyDto {
    return IRunOutPropertyDtoToJSONTyped(json, false);
}

export function IRunOutPropertyDtoToJSONTyped(value?: IRunOutPropertyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'run_out_days_amount': value['run_out_days_amount'],
        'run_out_type': value['run_out_type'],
        'run_out_type_state': value['run_out_type_state'],
    };
}

